import styled from "styled-components";

export const FilterContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  padding: 0;
  margin-bottom: 25px;
  gap: 8px;

    & div[disabled] {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const ExecutionLogContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0;
  margin-bottom: 25px;
  gap: 8px;

  & .title {
    font-size: 16px;
    font-weight: 600;
    color: #000;
  }
  & .description {
    font-size: 16px;
    color: #000;
  }
`;

export const TableContainer = styled.div`
  width: 100%;
  height: 100%;
  padding: 0;
  margin: 0;
  overflow-y: auto;
  overflow-x: hidden;

  &::-webkit-scrollbar {
    width: 8px;
  }
  
  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
  }
  
  &::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 4px;
  }
  
  &::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
  }

  table {
    width: 100%;
  }

  /* Event ID column */
  table thead th:nth-child(1) {
    width: 150px;
  }

  /* Event Name column - widest */
  table thead th:nth-child(2) {
    width: 300px;
  }

  /* Node column */
  table thead th:nth-child(3) {
    width: 150px;
  }

  /* Received Date column */
  table thead th:nth-child(4) {
    width: 200px;
  }

  /* Last Update column */
  table thead th:nth-child(5) {
    width: 200px;
  }

  /* Status column */
  table thead th:nth-child(6) {
    width: 150px;
  }

  table tbody td:nth-child(7) {
    width: 50px;
    & div {
      max-width: 27px;
    }
  }
`; 

export const StatusTag = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
  background-color: ${props => props.backgroundColor || '#F1F2F4'};
  color: ${props => props.textColor || '#313946'};
  white-space: nowrap;
  text-transform: capitalize;
`; 
